import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for Ora Cacao's "Boundless Belize 100% Cacao -
// Organic Ceremonial Chocolate" (p_4kl0c5dwr4), pulled from Faire's live
// `GET /api/product-reviews/product/{product_token}` endpoint — verbatim
// comment, real reviewer, real rating, real publish date.
export const review_oc5: FaireReviewEntity = {
  token: "review_oc5",
  type: "review",
  brandName: "Ora Cacao",
  brandToken: "b_djuc44eyt2",
  productToken: "p_4kl0c5dwr4",
  reviewType: "product",
  reviewerName: "Keith Skinner",
  reviewerLocation: "Camdenton, MO, United States",
  stars: 5,
  reviewText:
    "Boundless Belize is our 2nd best seller from Ora's Ceremonial Cacao options, second only to Oaxacan Spice. Thank you Ora!",
  reviewDate: "Jan 28, 2026",
  meta: {
    source: "api" as const,
    importedAt: "2026-08-11T20:50:10.000Z",
    importedBy: "entity-db-cli",
  },
};
